var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus128059(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2021_OP_symbolikuvitus_128_059",
    clipPath: "url(#clip0_7320_29440)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M128 0H0V128H128V0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M57.4299 75.3201V81.6601C57.4299 85.5901 61.1099 87.3401 64.4299 87.3401C67.7499 87.3401 71.4299 85.5901 71.4299 81.6601V75.3201H57.4299Z",
    fill: "white",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M57.44 81.1401L43.92 87.1401C38.15 89.7001 34.49 94.9701 34.49 100.74V108.13",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M71.4299 81.1401L84.9499 87.1401C90.7199 89.7001 94.3699 94.9701 94.3699 100.74V108.13",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81 62.6701C83.36 63.0801 84.12 60.8401 84.81 58.0901C85.64 54.7501 84.6 52.8201 82.24 52.4001",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 62.6701C83.36 63.0801 84.12 60.8401 84.81 58.0901C85.64 54.7501 84.6 52.8201 82.24 52.4001",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.82 62.6701C45.46 63.0801 44.7 60.8401 44.02 58.0901C43.18 54.7501 44.22 52.8201 46.58 52.4001",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.82 62.6701C45.46 63.0801 44.7 60.8401 44.02 58.0901C43.18 54.7501 44.22 52.8201 46.58 52.4001",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M82.24 49.0002C82.24 48.7902 82.24 48.5802 82.24 48.3802C78.75 45.5602 76 39.4502 76 39.4502C76 39.4502 70.86 43.9002 64.44 43.9002C58.02 43.9002 52.9 39.4502 52.9 39.4502C52.9 39.4502 50.13 45.5702 46.64 48.3902C46.64 48.6002 46.64 48.8002 46.64 49.0002C46.64 61.4402 48.49 66.5902 51.81 70.8102C55.13 75.0302 60.63 78.2002 64.44 78.2002C68.25 78.2002 74.31 75.0002 77.29 70.8102C80.27 66.6202 82.24 59.6502 82.24 49.0002Z",
    fill: "white",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M64.29 57.5601L62.81 62.0001C62.67 62.9301 62.92 63.5001 64.32 63.7601L66.09 64.0901",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M52.04 49.8H56.08",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M71.78 49.8H75.81",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M54.75 57.61C55.8821 57.61 56.7999 56.6922 56.7999 55.56C56.7999 54.4278 55.8821 53.51 54.75 53.51C53.6178 53.51 52.7 54.4278 52.7 55.56C52.7 56.6922 53.6178 57.61 54.75 57.61Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M74.1099 57.61C75.2421 57.61 76.1599 56.6922 76.1599 55.56C76.1599 54.4278 75.2421 53.51 74.1099 53.51C72.9778 53.51 72.0599 54.4278 72.0599 55.56C72.0599 56.6922 72.9778 57.61 74.1099 57.61Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M66.91 68.05C66.7674 68.5143 66.4797 68.9206 66.0891 69.2093C65.6985 69.4979 65.2256 69.6537 64.7399 69.6537C64.2543 69.6537 63.7814 69.4979 63.3908 69.2093C63.0002 68.9206 62.7125 68.5143 62.5699 68.05",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M83.22 37.6902C82.97 38.8402 83.48 40.7902 85.15 40.6902C85.4011 40.7053 85.6527 40.6685 85.8889 40.5821C86.1252 40.4957 86.3411 40.3615 86.5231 40.1879C86.7052 40.0143 86.8495 39.805 86.947 39.5731C87.0445 39.3412 87.0932 39.0917 87.09 38.8402C87.5366 39.2994 87.7864 39.9147 87.7864 40.5552C87.7864 41.1957 87.5366 41.811 87.09 42.2702C86.7694 42.6985 86.3662 43.0581 85.9041 43.3278C85.4421 43.5974 84.9306 43.7717 84.4 43.8402C85.1174 44.2989 85.6325 45.0143 85.84 45.8402C86.16 48.4302 84.49 48.6202 84.49 48.6202C84.8507 48.7839 85.1456 49.0644 85.3271 49.4165C85.5085 49.7685 85.5659 50.1715 85.49 50.5602C85.434 50.9984 85.28 51.4184 85.0393 51.7889C84.7987 52.1593 84.4776 52.4708 84.1 52.7002",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M45.76 52.6601C45.76 52.6601 42.54 53.6601 41.51 51.1801C40.1 47.7901 43.62 46.7601 43.62 46.7601C43.62 46.7601 40.07 48.6301 39.12 45.1001C38.9873 44.4739 39.0584 43.8216 39.3228 43.2387C39.5873 42.6557 40.0313 42.1727 40.59 41.8601C40.59 41.8601 41 44.0001 42.39 44.0001C45.39 44.0001 45.39 40.4801 42.88 39.5901C42.0739 39.3493 41.2231 39.298 40.3939 39.4403C39.5648 39.5825 38.7797 39.9144 38.1 40.4101C38.1 40.4101 38.85 36.4101 42.34 35.4101C42.34 35.4101 40.24 33.7201 38.62 34.2401C38.62 34.2401 39.4 30.9801 43.49 31.1701",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M43.61 31.1101C41.81 30.6501 41.42 29.7501 41.81 28.3101C42.28 26.6201 45.87 26.6901 47.53 26.3101C50.12 25.7801 51.07 25.3101 54.12 24.6701C60.33 23.3101 71.3 22.0501 77.06 31.5501C77.06 31.5501 81.56 30.4001 83.28 32.4301C84.35 33.6901 83.95 35.1801 83.57 36.4301L83.25 37.5501",
    stroke: "#6E6E6E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7320_29440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus128059);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_128_059.380161a1672c372e31b4766f315a2d58.svg";
export { ForwardRef as ReactComponent };